import "./TabelaExtratoAdmin.css";
import { FaRegEdit } from "react-icons/fa";
import { useState } from "react";
import Modal from "./Modal";
import FormularioComissao from "../../Formulario/FormularioComissao";
import FormularioPedidoOmie from "../../Formulario/FormularioPedidoOmie";

const TabelaExtratoAdmin = (props) => {
  const itens = props.itensLista || [];
  const licenciados = props.licenciados || [];

  const [open, setOpen] = useState(false);
  const [editItem, setEditItem] = useState(null); // guarda o item inteiro

  const abrirEdicao = (item) => {
    setEditItem(item);
    setOpen(true);
  };

  const fechar = () => {
    setOpen(false);
    setEditItem(null);
  };

  function formatCurrencyBRL(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return "R$ 0,00";
    return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  function formatarDataBRL(data) {
    if (!data) return "-";
    const d = new Date(data);
    if (isNaN(d.getTime())) return "-";
    const dia = String(d.getDate()).padStart(2, "0");
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    const ano = d.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  function renderizarStatus(status) {
    switch (status) {
      case "CONFIRMED":
        return <span className="status-pill status-credito">Confirmado</span>;
      case "PENDING":
        return <span className="status-pill status-analise">Pendente</span>;
      case "AWAITING_CONFIRMATION":
        return <span className="status-pill status-analise">Aguardando confirmação</span>;
      case "WITHDRAW_REQUESTED":
        return (
          <span className="status-pill status-saque-solicitado">
            Saque solicitado
          </span>
        );
      case "CANCELLED":
        return <span className="status-pill">Cancelado</span>;
      default:
        return <span className="status-pill">-</span>;
    }
  }

  const nomeLicenciado = (licenciado_id) => {
    const l = licenciados.find((x) => String(x.id) === String(licenciado_id));
    return l?.name || (licenciado_id ? `#${licenciado_id}` : "-");
  };

  return (
    <section className="table-card">
      <div className="table-title">{props.children}</div>

      <div className="table-tr">
        <table>
          <thead>
            <tr>
              <th>Data</th>
              <th>Licenciado</th>
              <th>Nº compra</th>
              <th>Cliente</th>
              <th>Valor compra</th>
              <th>Valor comissão</th>
              <th>Tipo</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>

          <tbody id="extratoTableBody">
            {itens.length === 0 && (
              <tr>
                <td colSpan={9} style={{ textAlign: "center" }}>
                  Nenhum lançamento encontrado
                </td>
              </tr>
            )}

            {itens.map((item) => {
              const isOmie = item.source === "OMIE";
              const isLedger = item.source === "LEDGER";
              const isSaque = isLedger && item.origin === "WITHDRAW";

              const valorCompra = Number(item.valor_compra) || 0;

              // comissão: se for Omie e não vier pronta, calcula no front pelo percentual
              const pct = Number(item.percentual) || 0;
              const comissaoCalc = pct > 0 ? (valorCompra * pct) / 100 : 0;
              const comissao = isOmie
                ? (Number(item.valor_comissao) || comissaoCalc || 0)
                : (Number(item.valor_comissao) || 0);

              const tipoLabel = isOmie ? "Pedido Omie" : (isSaque ? "Débito" : "Crédito");
              const tipoClass = isOmie ? "tipo-omie" : (isSaque ? "tipo-debito" : "tipo-credito");

              return (
                <tr key={item.uniqueKey || `${item.source}_${item.id}`}>
                  <td>{formatarDataBRL(item.data)}</td>
                  <td>{nomeLicenciado(item.licenciado_id)}</td>
                  <td>{item.numero || "-"}</td>
                  <td>{item.cliente || "-"}</td>
                  <td>{formatCurrencyBRL(valorCompra)}</td>
                  <td>{formatCurrencyBRL(isSaque ? -Math.abs(valorCompra) : comissao)}</td>

                  <td className={tipoClass}>{tipoLabel}</td>
                  <td>{renderizarStatus(item.status)}</td>

                  <td className="td-actions">
                    <button
                      type="button"
                      className="icon-btn"
                      title={isOmie ? "Vincular/confirmar pedido" : "Editar lançamento"}
                      onClick={() => abrirEdicao(item)}
                    >
                      <FaRegEdit />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Modal
        open={open}
        title={editItem?.source === "OMIE" ? "Pedido Omie" : "Editar lançamento"}
        onClose={fechar}
      >
        {editItem?.source === "LEDGER" && (
          <FormularioComissao
            licenciados={licenciados}
            modo="edit"
            editId={editItem?.id}
            onClose={fechar}
            lancamentoAtualizado={(itemAtualizado) => {
              props.onItemAtualizado?.(itemAtualizado);
              props.onReload?.(); // recarrega para manter a ordem e misturar com OMIE
              fechar();
            }}
          />
        )}

        {editItem?.source === "OMIE" && (
          <FormularioPedidoOmie
            licenciados={licenciados}
            pedido={editItem}
            onClose={fechar}
            onAtualizado={(patch) => {
              // patch leve (não obrigatório, pois no confirm vamos dar reload)
              props.onItemAtualizado?.({ id: editItem.id, ...patch });
            }}
            onReload={props.onReload}
          />
        )}
      </Modal>
    </section>
  );
};

export default TabelaExtratoAdmin;
